const LaunchIva = "LaunchIva";
const SwitchAcctIva = "SwitchAcctIva";
const ActiveCCSessonIVA = "ActiveCCSessonIVA";
const ManageAcctIva = "ManageAcctIva";
const DeepLinkReqCCTR = "DeepLinkReqCCTR";
const DeepLinkRespIva = "DeepLinkRespIva";
export default { LaunchIva, SwitchAcctIva, ActiveCCSessonIVA, ManageAcctIva, DeepLinkReqCCTR, DeepLinkRespIva };
